
import React from "react";
import "../user/UserProject.css";
import CardGrid from "./CardGrid";
import { MainLayout } from "../layout/MainLayout";
import { Zap } from "lucide-react";
const processingConfig = {
  transient: false, 
};

const ProjectProcessing = () => {
  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 p-6">
        <div className="max-w-7xl mx-auto">
          
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl mb-6 shadow-lg">
              <Zap className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-4">
              Project Processing
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Manage and process your digital twin projects with advanced raytracing and simulation tools
            </p>
          </div>
          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
            <div className="bg-gradient-to-r from-purple-600 to-pink-600 p-6">
              <div className="flex items-center gap-3">
                <Zap className="w-6 h-6 text-white" />
                <h2 className="text-2xl font-bold text-white">Processing Pipeline</h2>
              </div>
              <p className="text-purple-100 mt-2">Complete workflow for digital twin processing</p>
            </div>
            
            <div className="p-8">
              <CardGrid processingConfig={processingConfig} />
            </div>
          </div>

        </div>
      </div>
    </MainLayout>
  );
};

export default ProjectProcessing;